import {Button}       from './Button';
import {Header}       from './Header';
import {TabLoader}    from './TabLoader';
import {ScrollToTop}  from './ScrollToTop';
import {BlockHeading} from './BlockHeading';
import {LanguageSwitcher} from './LanguageSwitcher';
import {TabScaffold} from './TabScaffold';
import {BottomTabBar} from '../navigation/BottomTabBar';
import {BottomSheet}  from './BottomSheet';
import {InstallPrompt} from './InstallPrompt';

export const components = {
  Button,
  Header,
  TabLoader,
  ScrollToTop,
  BlockHeading,
  LanguageSwitcher,
  TabScaffold,
  BottomTabBar,
  BottomSheet,
  InstallPrompt,
};
